<template>
  <v-app id="app">
    <piv-entete v-on:basculeAfficherMenu="afficherMenu = !afficherMenu"></piv-entete>
    <v-main>
      <AlerteErreur v-model="erreur"></AlerteErreur>

      <router-view />
    </v-main>
    <piv-pied-page></piv-pied-page>
  </v-app>
</template>

<script>
import { bus } from '@/main';
import '@/assets/piv.css';
import '@/assets/coursete.css';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import useAppStore from '@/store/appStore';
import useInscriptionStore from '@/store/inscriptionStore';
import usePanierStore from '@/store/panierStore';
import pivPiedPage from '@/components/layout/pivPiedPage.vue';
import pivEntete from '@/components/layout/pivEntete.vue';
import AlerteErreur from '@/components/custom/VueAlerteErreur.vue';
import csqcOutilsCoursEte from '@/outils/CSQCOutilsCoursEte';

const racineLocalStorage = 'csqc_coursEte_';
const localStoragePanier = 'Panier';

export default {
  name: 'App',
  components: {
    // MenuPrincipal,
    pivPiedPage,
    pivEntete,
    AlerteErreur,
  },
  setup() {
    const appStore = useAppStore();
    const inscriptionStore = useInscriptionStore();
    const panierStore = usePanierStore();

    return { appStore, inscriptionStore, panierStore };
  },
  data: () => ({
    afficherMenu: false,
    erreur: '',
  }),
  async created() {
    this.appStore.modele = window.modele;
    this.appStore.texteDynamique = JSON.parse(this.appStore.modele.optionRegionale.textePagePrincipaleJSON);

    window.addEventListener('resize', this.verifierMobile);

    this.appStore.nomRegion = this.appStore.modele.optionRegionale.nomRegionCoursEte ?? '';

    bus.$on('erreur', (data) => {
      this.erreur += `${data}<br>`;
    });
    bus.$on('erreur_module', (data) => {
      this.erreur += `${this.$tc(data)}<br>`;
    });

    await this.inscriptionStore.definirListeCSSMinimise();
    this.selectOffreCours = this.obtenirCssSelectionneLocalStorage;

    await this.inscriptionStore.definirBlocOrganisme(this.appStore.modele.anneeEnSeptembre); // Todo trouver comment avoir l'année scolaire

    await this.panierStore.definirListeCoursPanier(this.getCoursPanier);
  },
  computed: {
    getCoursPanier() {
      const panierContenu = localStorage.getItem(
        racineLocalStorage + localStoragePanier,
      );
      if (JSON.parse(panierContenu) == null) {
        return [];
      }
      return JSON.parse(panierContenu);
    },
    estScolariseMaison() {
      return csqcOutilsCoursEte.EstScolariseMaison();
    },
  },
  methods: {
    fermerMenu(afficherMenu) {
      this.afficherMenu = afficherMenu;
      const btn = document.querySelector('.toggle_btn');
      btn.classList.toggle('toggle_btn_open');
    },
    fermerMenuClickOutside(monclick) {
      if (this.afficherMenu === true) {
        if (
          monclick.target.className !== 'toggle_btn toggle_btn_open' &&
          monclick.target.parentElement != null &&
          monclick.target.parentElement.className !==
          'toggle_btn toggle_btn_open'
        ) {
          const btn = document.querySelector('.toggle_btn');
          btn.classList.toggle('toggle_btn_open');
          this.afficherMenu = false;
        }
      }
    },

    verifierMobile() {
      this.appStore.estMobile = window.innerWidth <= 960; // équivaut à sm de $vuetify.breakpoint
    },
  },
  destroyed() {
    // Avec Vue 3, destroyed doit être remplacé par beforeUnmount
    window.removeEventListener('resize', this.verifierMobile);
  },
};
</script>

<style scoped lang="css">
@import "../node_modules/csqc-composants-ui/src/CsqcGlobals/CSQC.css";
.container {
  padding: 0;
}
</style>
